<template>
  <div class="report">
    <headBar headbartype="report"></headBar>
    <div class="report_body">
      <div class="title">{{userInfo.username}}的日程{{reportTypeName}}报</div>
     <!-- <div class="date">
        <span class="text">日期： {{startDateShow}} ~ {{endDateShow}}</span>
        <span class="date_btn">切换日期</span>
      </div>-->
      <div class="report_form">
        <div class="outline">
          <div class="sub_title">
            <i class="icon iconfont icon-tongji2"></i><span>本{{reportTypeName}}日程统计</span>
            <span class="time"><i class="icon iconfont icon-left-circle-fill" @click="preReport"></i>{{reportStartTime | dateFormat('YYYY.MM.DD')}}~{{reportEndTime | dateFormat('YYYY.MM.DD')}}<i class="icon iconfont icon-right-circle-fill" @click="nextReport"></i></span>
          </div>
          <div v-show="resultAllData.taskList.length !== 0" class="content">
            <div class="content_text"><i class="icon iconfont icon-richeng"></i>本{{reportTypeName}}共{{resultAllData.allCount}}个日程，{{resultAllData.completeCount}}个完成，{{resultAllData.unCompleteCount}}个未完成</div>
            <div class="content_charts">
              <div class="pie_div">
                <reportChartComponent :dataPie="resultAllData.allTask"></reportChartComponent>
              </div>
              <div class="bar_div">
                <div class="bar_div_uncomplete">
                  <barComponent v-if="resultAllData.unCompleteTask.length !=0" :dataBar="resultAllData.unCompleteTask" refName="unCompleteTask" titleName='未完成项目统计'></barComponent>
                </div>
                <div class="bar_div_completed">
                  <barComponent v-if="resultAllData.completeTask.length !=0" :dataBar="resultAllData.completeTask" refName="completeTask" titleName='已完成项目统计'></barComponent>
                </div>
              </div>
            </div>
          </div>
          <div v-show="resultAllData.taskList.length === 0" class="no_content">
            <div class="pic"><img src="../../../static/img/presentation.png"></div>
            <div class="text_1">本{{reportTypeName}}{{reportTypeName}}报还未生成</div>
            <div class="text_2">{{reportTypeName}}报会在每{{reportTypeName}}末生成，现在可以查看其他{{reportTypeName}}报</div>
          </div>
        </div>
        <div v-show="resultAllData.taskList.length !== 0" class="detail">
          <div class="sub_title"><i class="icon iconfont icon-xiangqing"></i><span>本{{reportTypeName}}日程详情</span></div>
          <div class="content">
            <div class="tab_head">
              <div class="tab_head_icon"><i class="icon iconfont icon-solid-time"></i></div>
              <div class="tab_head_completed"><div class="text">已完成</div><div class="num">{{resultAllData.completeCount}}</div></div>
              <div class="tab_head_unComplete"><div class="text">未完成</div><div class="num">{{resultAllData.unCompleteCount}}</div></div>
            </div>
            <div class="tab_body" v-for="(detailObj, index) in detailData" :key="index">
              <div class="tab_body_date">
                <div class="tab_body_date_wrap">
                  <div class="weekday">周{{detailObj.week}}</div>
                  <div class="date">{{detailObj.month}}月{{detailObj.day}}日</div>
                </div>
              </div>
              <div class="tab_body_completed">
                <div class="schedule_item" v-for="(schedule, index) in detailObj.completedList" :key="index">
                  <div class="schedule_item_title">{{schedule.title}}</div>
                  <div v-show="schedule.content !== undefined" class="schedule_item_content">{{schedule.content}}</div>
                  <div class="schedule_item_bottom">
                    <div class="schedule_item_category" :style="{background: schedule.color}">{{schedule.category_name}}</div>
                    <div v-show="schedule.team_name !== undefined" class="schedule_item_team_name">{{schedule.team_name}}</div>
                    <div class="schedule_item_time"><i class="icon iconfont icon-richeng"></i>{{schedule.start_time}}-{{schedule.end_time}}</div>
                  </div>
                </div>
              </div>
              <div class="tab_body_unComplete">
                <div class="schedule_item" v-for="(schedule, index) in detailObj.unCompleteList" :key="index">
                  <div class="schedule_item_title">{{schedule.title}}</div>
                  <div v-show="schedule.content !== undefined" class="schedule_item_content">{{schedule.content}}</div>
                  <div class="schedule_item_bottom">
                    <div class="schedule_item_category" :style="{background: schedule.color}">{{schedule.category_name}}</div>
                    <div v-show="schedule.team_name !== undefined" class="schedule_item_team_name">{{schedule.team_name}}</div>
                    <div class="schedule_item_time"><i class="icon iconfont icon-richeng"></i>{{schedule.start_time}}-{{schedule.end_time}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import headBar from './component/headBar.vue'
import reportChartComponent from '../others/reportChartComponent.vue'
import barComponent from '../others/barComponent.vue'
import axios from 'axios'
import moment from 'moment'
import {mapState} from 'vuex'
export default {
  name: 'report',
  components: {
    headBar,
    reportChartComponent,
    barComponent
  },
  data: function () {
    return {
      resultAllData: {
        allCount: 0,
        completeCount: 0,
        unCompleteCount: 0,
        taskList: [],
        allTask: [],
        completeTask: [],
        unCompleteTask: []
      }
    }
  },
  filters: {
    dateFormat: function (value, format) {
      return moment(value).format(format)
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'reportType',
      'reportStartTime',
      'reportEndTime'
    ]),
    reportTypeName () {
      if (this.reportType === 'week') {
        return '周'
      } else if (this.reportType === 'month') {
        return '月'
      }
    },
    detailData () {
      let detailObj = {}
      // 周报
      if (this.reportType === 'week') {
        this.resultAllData.taskList.forEach((e, i) => {
          // week 星期日：1 星期一：2
          if (e.week === 2) {
            // 判断是否已存在星期一的对象
            if (Object.keys(detailObj).indexOf('a_mon') >= 0) {
              let weekObj = detailObj.a_mon
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '一',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.a_mon = weekObj
            }
          } else if (e.week === 3) {
            if (Object.keys(detailObj).indexOf('b_tues') >= 0) {
              let weekObj = detailObj.b_tues
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '二',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.b_tues = weekObj
            }
          } else if (e.week === 4) {
            if (Object.keys(detailObj).indexOf('c_wed') >= 0) {
              let weekObj = detailObj.c_wed
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '三',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.c_wed = weekObj
            }
          } else if (e.week === 5) {
            if (Object.keys(detailObj).indexOf('d_thur') >= 0) {
              let weekObj = detailObj.d_thur
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '四',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.d_thur = weekObj
            }
          } else if (e.week === 6) {
            if (Object.keys(detailObj).indexOf('e_fri') >= 0) {
              let weekObj = detailObj.e_fri
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '五',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.e_fri = weekObj
            }
          } else if (e.week === 7) {
            if (Object.keys(detailObj).indexOf('f_sat') >= 0) {
              let weekObj = detailObj.f_sat
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '六',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.f_sat = weekObj
            }
          } else if (e.week === 1) {
            if (Object.keys(detailObj).indexOf('g_sun') >= 0) {
              let weekObj = detailObj.g_sun
              this.setDetailSchedule(e, weekObj)
            } else {
              let weekObj = {
                week: '日',
                month: moment(e.complete_time).format('MM'),
                day: moment(e.complete_time).format('DD'),
                completedList: [],
                unCompleteList: []
              }
              this.setDetailSchedule(e, weekObj)
              detailObj.g_sun = weekObj
            }
          } else {
            console.log('week数据错误')
          }
        })
        let detailArr = []
        if (Object.keys(detailObj).indexOf('a_mon') >= 0) {
          detailArr.push(detailObj.a_mon)
        }
        if (Object.keys(detailObj).indexOf('b_tues') >= 0) {
          detailArr.push(detailObj.b_tues)
        }
        if (Object.keys(detailObj).indexOf('c_wed') >= 0) {
          detailArr.push(detailObj.c_wed)
        }
        if (Object.keys(detailObj).indexOf('d_thur') >= 0) {
          detailArr.push(detailObj.d_thur)
        }
        if (Object.keys(detailObj).indexOf('e_fri') >= 0) {
          detailArr.push(detailObj.e_fri)
        }
        if (Object.keys(detailObj).indexOf('f_sat') >= 0) {
          detailArr.push(detailObj.f_sat)
        }
        if (Object.keys(detailObj).indexOf('g_sun') >= 0) {
          detailArr.push(detailObj.g_sun)
        }
        return detailArr
        // 月报
      } else if (this.reportType === 'month') {
        let detailObj = {}
        this.resultAllData.taskList.forEach((e, i) => {
          let date = moment(e.complete_time).format('YYYY_MM_DD')
          console.log(date)
          if (Object.keys(detailObj).indexOf(date) >= 0) {
            let monthObj = detailObj[date]
            this.setDetailSchedule(e, monthObj)
          } else {
            let weekName = ''
            if (e.week === 2) {
              weekName = '一'
            } else if (e.week === 3) {
              weekName = '二'
            } else if (e.week === 4) {
              weekName = '三'
            } else if (e.week === 5) {
              weekName = '四'
            } else if (e.week === 6) {
              weekName = '五'
            } else if (e.week === 7) {
              weekName = '六'
            } else if (e.week === 1) {
              weekName = '日'
            } else {
              weekName = ''
            }
            let monthObj = {
              week: weekName,
              month: moment(e.start_time).format('MM'),
              day: moment(e.start_time).format('DD'),
              completedList: [],
              unCompleteList: []
            }
            this.setDetailSchedule(e, monthObj)
            detailObj[date] = monthObj
          }
        })
        console.log(detailObj)
        let detailArr = []
        Object.keys(detailObj).forEach((e, i) => {
          detailArr.push(detailObj[e])
        })
        return detailArr
      }
    }
  },
  methods: {
    setDetailSchedule (e, obj) {
      // 判断是否已完成 status 1：未完成 2：已完成
      if (e.status === 1) {
        let unCompleteObj = {
          title: e.title,
          content: e.content,
          category_name: e.category_name,
          color: e.color,
          start_time: moment(e.start_time).format('YYYY/MM/DD'),
          end_time: moment(e.end_time).format('YYYY/MM/DD'),
          team_name: e.team_name
        }
        obj.unCompleteList.push(unCompleteObj)
      } else if (e.status === 2) {
        let completedObj = {
          title: e.title,
          content: e.content,
          category_name: e.category_name,
          color: e.color,
          start_time: moment(e.start_time).format('YYYY/MM/DD'),
          end_time: moment(e.end_time).format('YYYY/MM/DD'),
          team_name: e.team_name
        }
        obj.completedList.push(completedObj)
      } else {
        console.log('status错误')
      }
    },
    getStatisticTask () {
      let _this = this
      console.log(_this.reportStartTime)
      console.log(_this.reportEndTime)
      axios({
        method: 'get',
        url: _this.HOST + '/task/getStatisticTask',
        params: {
          check_user_no: _this.$store.state.userInfo.user_no,
          user_no: _this.$store.state.userInfo.user_no,
          start_time: _this.reportStartTime,
          end_time: _this.reportEndTime
        }
      }).then(function (response) {
        let data = response.data
        console.log('周报月报')
        console.log(data)
        if (data.statusCode === 200) {
          _this.resultAllData = data.data
        } else {
          console.log(data.message)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    preReport () {
      if (this.reportType === 'week') {
        console.log('前一周')
        this.$store.dispatch('setReportStartTime', moment(this.reportStartTime).subtract(7, 'days').startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
        this.$store.dispatch('setReportEndTime', moment(this.reportEndTime).subtract(7, 'days').endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
      } else if (this.reportType === 'month') {
        this.$store.dispatch('setReportStartTime', moment(this.reportStartTime).subtract(1, 'months').startOf('month').format('YYYY-MM-DD HH:mm:ss'))
        this.$store.dispatch('setReportEndTime', moment(this.reportEndTime).subtract(1, 'months').endOf('month').format('YYYY-MM-DD HH:mm:ss'))
      }
      this.getStatisticTask()
    },
    nextReport () {
      if (this.reportType === 'week') {
        this.$store.dispatch('setReportStartTime', moment(this.reportStartTime).add(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
        this.$store.dispatch('setReportEndTime', moment(this.reportEndTime).add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'))
      } else if (this.reportType === 'month') {
        this.$store.dispatch('setReportStartTime', moment(this.reportStartTime).add(1, 'months').startOf('month').format('YYYY-MM-DD HH:mm:ss'))
        this.$store.dispatch('setReportEndTime', moment(this.reportEndTime).add(1, 'months').endOf('month').format('YYYY-MM-DD HH:mm:ss'))
      }
      this.getStatisticTask()
    }
  },
  mounted () {
    this.getStatisticTask()
  },
  watch: {
    reportType: function (newVal, oldVal) {
      this.getStatisticTask()
    }
  }
}
</script>

<style lang="stylus">
  .report
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    overflow scroll
    background url("../../../static/img/report_bg_1x.png") no-repeat
    background-size cover
    // .headBar
    //   box-shadow 0 0 0 0
    //   -moz-box-shadow 0 0 0 0
    //   -webkit-box-shadow 0 0 0 0
    //   .logo
    //     .logo_text
    //       color $white
    //   .right_menu
    //     .report_menu,.member
    //       color $white
  .report_body
    color $white
    padding 2rem 5%
    .title
      height 2.1875rem
      line-height  2.1875rem
      font-size 30px
      font-weight 500
      margin-bottom 1.375rem
    .date
      height 1.75rem
      line-height  1.75rem
      .text
        display inline-block
        vertical-align top
        font-size 1.5rem
        font-weight 500
        margin-right 1.875rem
      .date_btn
        display inline-block
        vertical-align top
        width 6.125rem
        height 1.6rem
        line-height 1.6rem
        text-align center
        border-radius 1rem
        color $pepperGrey
        background $white
        cursor pointer
    .report_form
      width 100%
      .outline
        .sub_title
          border-top-left-radius 1.25rem
          border-top-right-radius 1.25rem
          padding 0.8rem 1.5rem
          height 2rem
          font-size 22px
          font-weight 500
          background $deepGrey
          i
            font-size 22px
            display inline-block
            margin-right 1rem
          .time
            color $tinGrey
          span
            font-size 22px
            display inline-block
            margin-right 1rem
            i
              color $tinGrey
            i:hover
              color $white
              cursor pointer
            .icon-left-circle-fill
              margin-right 0.5rem
            .icon-right-circle-fill
              margin-left 0.5rem
        .no_content
          background $white
          border-bottom-left-radius 20px
          border-bottom-right-radius 20px
          .pic
            padding-top 150px
            padding-bottom 80px
            text-align center
            img
              width 150px
              height 150px
          .text_1
            color $pepperGrey
            text-align center
            font-size 30px
            font-weight 500
          .text_2
            color $lightGrey
            text-align center
            font-size 18px
            padding-top 15px
            padding-bottom 200px
        .content
          background $white
          padding 1rem
          .content_text
            height 2.125rem
            line-height 2.125rem
            color $elemBlue
            font-size 22px
            font-weight 500
            i
              font-size 22px
              margin-right 1rem
          .content_charts
            margin-top 1.5rem
            display flex
            display -webkit-flex
            .pie_div
              flex 2
              canvas
                height 100%
            .bar_div
              flex 3
              .bar_div_uncomplete
                margin 0 5rem 1rem 5rem
              .bar_div_completed
                margin 0 5rem 0 5rem
      .detail
        .sub_title
          padding 0.8rem 1.5rem
          height 2rem
          font-size 22px
          font-weight 500
          background $deepGrey
          i
            font-size 22px
            display inline-block
            margin-right 1rem
        .content > .tab_body:last-child
          .tab_body_date
            border-bottom-left-radius 43px
          .tab_body_unComplete
            border-bottom-right-radius 43px
        .content > .tab_body:not(:last-child)
          .tab_body_date
            border-bottom 1px solid $white
        .content > .tab_body:nth-child(even)
          .tab_body_completed
            background $bgGray
          .tab_body_unComplete
            background $bgRed
        .content > .tab_body:nth-child(odd)
          .tab_body_completed,
          .tab_body_unComplete
            background $white
        .content
          background transparent
          .tab_head
            display flex
            height 3rem
            border-bottom 2px solid $tinGrey
            .tab_head_icon
              height 3rem
              line-height 3rem
              display inline-block
              vertical-align top
              flex 2
              background $elemBlue
              i
                display block
                font-size 1.5rem
                text-align center
                color $white
            .tab_head_completed,
            .tab_head_unComplete
              background $white
              display inline-block
              vertical-align top
              height 3rem
              flex 9
              color $pepperGrey
              font-size 18px
              font-weight 500
              text-align center
              line-height 3rem
              .text
                display inline-block
                vertical-align middle
              .num
                vertical-align middle
                display inline-block
                width 18px
                height 18px
                line-height 20px
                border-radius 50%
                margin-left 30px
                color $white
                font-size 14px
            .tab_head_completed
              .num
                background $green
            .tab_head_unComplete
              .num
                background $red
          .tab_body
            display flex
            .tab_body_date
              flex 2
              background $elemBlue
              .tab_body_date_wrap
                height 100%
                display flex
                flex-direction column
                align-items center
                justify-content center
                font-size 18px
                .weekday
                  font-size 18px
                .date
                  font-size 14px
            .tab_body_completed
              border-right 1px solid $bgGray
            .tab_body_completed,
            .tab_body_unComplete
              flex 9
              color $pepperGrey
              padding-bottom 15px
              .schedule_item
                padding 10px 20px 0 20px
                .schedule_item_title
                  font-size 14px
                  line-height 22px
                .schedule_item_content
                  font-size 12px
                  line-height 18px
                  color $lightGrey
                .schedule_item_bottom
                  margin-top 11px
                  .schedule_item_category
                    display inline-block
                    vertical-align top
                    font-size 12px
                    background $pepperGrey
                    color $white
                    text-align center
                    width 40px
                    height 18px
                    border-radius 4px
                    margin-right 16px
                  .schedule_item_team_name
                    display inline-block
                    vertical-align top
                    font-size 12px
                    background $white
                    color $elemBlue
                    border 1px solid $elemBlue
                    text-align center
                    min-width 60px
                    height 18px
                    border-radius 4px
                    margin-right 16px
                  .schedule_item_time
                    display inline-block
                    vertical-align top
                    font-size 12px
                    color $lightGrey
                    i
                      margin-right 10px
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/report.vue